import { Tabs } from 'react-tabs'
import Flex from 'typescript-styled-flex'
import styled from '../../../theme'

const BBTabs = styled(Flex.withComponent(Tabs) as any)<any>`
  display: block;
  padding: 0px;
  margin: 0px;
`

export default BBTabs
